import React, { Component } from "react";
import { IconButton, Grid, Card, Icon, withStyles } from "@material-ui/core";
import * as actions from "../../store/actions/index";
import { connect } from "react-redux";
import { compose } from "redux";
import ListComponent from "../Common/ListComponent";


const IconSmall = withStyles(() => ({
  root: {
    fontSize: "1.5rem",
    color: "rgba(0, 0, 0, 0.6)",
  },
}))(Icon);

class ContactProfileRight extends Component {
  state = {
    attachment: null,
    activedatas: [],
    updatelistorder: true,
  };

  componentDidMount() {
    let val = { recordtypeid: 2 }
    this.props.getRelatedMasterList(this.props.apolloClient.client, val);
      console.log("this.props.contact_id", this.props.contact_id);
    if(this.props.contact_id){
        this.setState({
            contact_id:this.props.contact_id,
        },()=>{
            this.forceUpdate()
        });
    }

  }
  componentWillReceiveProps(props) {
    if (props.contact_id != this.state.contact_id) {
          this.setState({
              contact_id:parseInt(props.contact_id),
          },()=>{
              this.forceUpdate()
          });
    }
    if (props.settingReducer.contactrelatedMaster.data) {
      const contactrelatedMaster = props.settingReducer.contactrelatedMaster.data;
      let activedatas = [];

      contactrelatedMaster.map((fieldData, index) => {
        if (fieldData.isactive === true) {
          activedatas.push({
            key: fieldData.id,
            alias: fieldData.alias,
            isactive: fieldData.isactive,
            orderid: fieldData.orderno,
          });
        }
      });
      if (this.state.updatelistorder == true){
        this.setState({ activedatas: activedatas }, () => this.forceUpdate());
      }
    }
  }

  render() {
    return (
      <>
        {this.state.contact_id && <ListComponent recordId= {this.state.contact_id} recordtype={"contact"} activedata={this.state.activedatas} relate allData={this} />}
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    settingReducer: state.settingReducer,
    apolloClient: state.apolloClient,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getRelatedMasterList: (client, request) => {
      dispatch(actions.getRelatedMasterList(client, request));
    },
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
    ContactProfileRight
);


